module.exports = __webpack_public_path__ + "static/img/2.39aba77.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.png
// module id = B8sb
// module chunks = 1